import PropTypes from "prop-types";
import {Link} from "react-router-dom";

const ServiceLink = ({className,link,icon,name,type}) => {
    const classNames={
        Water:"water",
        TelBills:"tel",
        MobileBills:"mobile",
        GasByBillId:"gas",
        Electricity:"electricity"
    }
    return <Link to={link} className={`t-service-link  ${className}`}>
                    <div className={`${classNames[type]}`}>{<img src={icon} alt={name}/>}</div>
                    <span className="text-center mt-1 ">{name}</span>
            </Link>
}
ServiceLink.propTypes = {
    className: PropTypes.string,
    link: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    type:PropTypes.oneOf(['Water','MobileBills','TelBills','Electricity','GasByBillId']).isRequired
}
ServiceLink.defaultProps = {
    className: "",
    link: "",
    name:"",
    icon:"",
}
export default ServiceLink;